import * as Sentry from '@sentry/vue';
export const captureException = (exception, contexts = {}) => {
  return Sentry.captureException(exception, {
    contexts,
  });
};
